import { useSalesStore } from '../stores/sales.store'

export function useSales() {
  const sales = useSalesStore((state) => state.sales)
  const isLoading = useSalesStore((state) => state.isLoading)
  const error = useSalesStore((state) => state.error)
  const meta = useSalesStore((state) => state.meta)

  const fetchSales = useSalesStore((state) => state.fetchSales)

  const createSalesPerson = useSalesStore((state) => state.createSalesPerson)

  const updateSalesPerson = useSalesStore((state) => state.updateSalesPerson)

  const deleteSalesPerson = useSalesStore((state) => state.deleteSalesPerson)
  const assignSalesTarget = useSalesStore((state) => state.assignSalesTarget)

  const clearError = useSalesStore((state) => state.clearError)

  return {
    sales,
    meta,
    isLoading,
    error,
    fetchSales,
    createSalesPerson,
    updateSalesPerson,
    deleteSalesPerson,
    assignSalesTarget,
    clearError,
  }
}
